import { Component, Input, WritableSignal, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteFormFooterComponent, RouteFormHeaderComponent } from './components';
import { SelectRouteFormComponent } from './components/select-route-form';
import { RouteFormOptionsPanelsComponent } from './components/route-form-options-panels/route-form-options-panels.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoPipe } from '@ngneat/transloco';
import { SelectRoutePlacesService } from './components/select-route-form/services/select-route-places.service';
import { RouteFormService } from './services/route-form.service';
import { RouteFormResult } from './models/routeRequestResults.model';
import { filter, tap } from 'rxjs';
import { UtilsService } from '@shared/services/utils.service';
import { CoreService } from '@core/services';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-route-form',
  standalone: true,
  imports: [CommonModule, RouteFormHeaderComponent, RouteFormFooterComponent, SelectRouteFormComponent, RouteFormOptionsPanelsComponent, MatButtonModule, TranslocoPipe],
  templateUrl: './route-form.component.html',
  styleUrls: ['./route-form.component.scss']
})
export class RouteFormComponent {

  @Input({required: true}) routeFormResults!: WritableSignal<RouteFormResult|null>;
  private selectRoutePlacesService = inject(SelectRoutePlacesService);
  private routeFormService = inject(RouteFormService);
  private utils = inject(UtilsService);
  private coreService = inject(CoreService);
  public isSearchButtonDisabled = computed(() => {
    return !this.selectRoutePlacesService.selectedFromOption() || !this.selectRoutePlacesService.selectedToOption();
  })

  public loading = toSignal(this.coreService.loadingRouteResults);

  

  public searchButtonClicked() {
    this.coreService.setLoadingRouteResults(true);
    this.routeFormService.doSearchRequest()
    .pipe(
      tap((result) => {
        if(!result) this.coreService.setLoadingRouteResults(false);
      }),
      filter((result) => !!result),
    )
    .subscribe({
      next: (result) => {
        this.routeFormResults.set(result);
        this.coreService.setLoadingRouteResults(false);
      },
      error: (error) => {
        this.utils.showSnackBarError();
        this.coreService.setLoadingRouteResults(false);
      }
    })
    

  }

  public cleanForms() {
    this.coreService.cleanFormConfigurationFields();
  }

}
